import React from "react";
import SemiDonutChart from "./charts/SemiDonutChart";

export default function ChartRenderer({ type = "semiDonut", data = {}, height = 200 }) {
  switch (type) {
    case "semiDonut":
      return <SemiDonutChart values={data} height={height} />;

    // Future extensions
    case "bar":
      return <div>Bar chart coming soon</div>;

    case "line":
      return <div>Line chart coming soon</div>;

    default:
      return <div>Unknown chart type: {type}</div>;
  }
}